import { render, staticRenderFns } from "./Bezier.vue?vue&type=template&id=bde9cec2&"
import script from "./Bezier.vue?vue&type=script&lang=js&"
export * from "./Bezier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports